module.exports = __webpack_public_path__ + "static/img/activity_sdy_05-3.f3ef667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_05-3.jpg
// module id = BdeE
// module chunks = 0